module.exports = __webpack_public_path__ + "img/glitter_4.e2d95766.jpg";